import { create } from 'zustand';
import { ApiUtils, CountryEntity, MiscApi, RequestStrategyEnum } from '@shared/api';

interface ICountriesStore {
  loading: boolean;
  error: string | null;
  countries: CountryEntity[];
  getCountries: (signal?: AbortSignal) => Promise<void>;
  clear: () => void;
}

export const useCountriesStore = create<ICountriesStore>((set) => ({
  loading: false,
  error: null,
  countries: [],

  getCountries: ApiUtils.wrapperApi(async (signal?: AbortSignal) => {
    try {
      set({ loading: true, error: null });
      const result = await MiscApi.getCountries(signal);
      set({ countries: result?.filter((country) => Boolean(country.code)) ?? [], loading: false });
    } catch (error) {
      set({ error: (error as Error).message, loading: false });
    }
  }, RequestStrategyEnum.Debounce),

  clear: () => set({ countries: [], loading: false, error: null }),
}));
